import React from 'react';
import styled, { css } from 'styled-components';
import { BtnProps } from '../help/interfaces';
import { translate } from '../help/functions';

export const Btn: React.FC<BtnProps> = ({ value, conditionSelected, setConditionSelected }) => {
  const selected = value === conditionSelected;

  return (
    <Conponent selected={selected} onClick={setConditionSelected(value)}>
      {translate[value]}
    </Conponent>
  );
};

const Conponent = styled.button<{ selected?: boolean }>`
  ${({ theme, selected }) => css`
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;
    padding: 16px;
    border-radius: 16px;
    background-color: transparent;
    font-weight: ${selected ? '700' : '0'};
    color: ${selected ? theme.grey.darker : theme.grey.light};
    border: ${selected ? `2px solid ${theme.grey.darker}` : `1px solid ${theme.grey.light}`};

    @media (min-width: 700px) {
      padding: 8px 16px;
      border-radius: 3px;
      border: 1px solid ${selected ? theme.grey.darker : theme.grey.light};
    }
  `}
`;

export default Btn;
